import React, { useState, useEffect } from 'react';
import {  } from 'react-icons/fi';
import CardTemplates from '../../../app/components/CardTemplates';
import { Tabs } from '../../../app/components/Tabs';
import { FiFileText } from "react-icons/fi";
import Input from '../../../app/components/Input';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../../../contexts/PageTitleContext';


const TemplatesSequencia = () => {
  const navigate = useNavigate();
    const { setTitle } = usePageTitle();
  
    useEffect(() => {
      setTitle('Templates de Sequências');
    }, [setTitle]);

  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('Desenvolvimento');

  const departments = ['Desenvolvimento', 'RH', 'Comercial', 'Deploy e Testes', 'Sucesso'];

  const templates = [
    { id: 1, title: "Solicitações de Suporte", icon: <FiFileText />,description:'Template para Controle e Tratamento de Erros.', department: "Desenvolvimento" },
    { id: 2, title: "Checklist de Onboarding", icon: <FiFileText />,description:'Template para Controle e Tratamento de Erros.', department: "RH" },
    { id: 3, title: "Requisição de Material", icon: <FiFileText />,description:'Template para vendas e negociações.', department: "Comercial" },
    { id: 4, title: "Relatório de Vendas", icon: <FiFileText />,description:'Template para vendas e negociações.', department: "Comercial" },
    { id: 5, title: "Plano de Carreira", icon: <FiFileText />,description:'Template para vendas e negociações.', department: "RH" },
    { id: 6, title: "Deploy Checklist", icon: <FiFileText />,description:'Template para vendas e negociações.', department: "Deploy e Testes" },
    { id: 7, title: "Feedback de Cliente", icon: <FiFileText />,description:'Template para vendas e negociações.', department: "Sucesso" },
  ];

  const handleDepartmentClick = (department) => {
    setSelectedDepartment(department);
    setSearchTerm('');
  };

  const handleUseTemplate = (id, title) => {
    navigate('/sequencia');
  };

  const renderContentByDepartment = () => {
    const filteredTemplates = templates.filter((template) => {
      const matchesSearch = template.title.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesDepartment = template.department === selectedDepartment;
      return matchesSearch && matchesDepartment;
    });

    if (filteredTemplates.length === 0) {
      return (
        <div className="text-center py-8 text-gray-500">
          Nenhum template encontrado para este departamento.
        </div>
      );
    }

    return (
      <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredTemplates.map((template) => (
          <CardTemplates
            variant='primary'
            key={template.id}
            title={template.title}
            description={template.description}
            icon={template.icon}
            department={template.department}
            onClick={() => handleUseTemplate(template.id, template.title)}
          />
        ))}
      </div>
    );
  };

  return (
    <div>
      <div className="bg-white rounded-2xl shadow-sm border-gray-200 min-h-screen">
        <Tabs
          tabsName={departments}
          activeTabName={selectedDepartment}
          onTabClick={handleDepartmentClick}
        />

        <div className="flex flex-col justify-between items-top sm:flex-row sm:items-center mb-4 sm:mb-6 space-y-3 sm:space-y-0 mt-6">
            <Input
              type="text"
              size="xs"
              variant="search"
              value={searchTerm}
              label="Pesquisar"
              onChange={(e) => setSearchTerm(e.target.value)}
            />
        </div>


        {renderContentByDepartment()}
      </div>
    </div>
  );
};

export default TemplatesSequencia;
